import React from 'react';
import { Badge } from 'react-bootstrap';
import { FaCheckCircle, FaQuestionCircle, FaTimesCircle, FaWarehouse } from 'react-icons/fa';

function ItemSalesStatusBadge({ status }){
    
  const getStatusBadge = (status) => {
    switch (status) {
      case 'available':
        return (
          <Badge bg="success" className="d-flex align-items-center">
            <FaWarehouse className="me-2" /> Available
          </Badge>
        );
      case 'sold':
        return (
          <Badge bg="danger" className="d-flex align-items-center">
            <FaCheckCircle className="me-2" /> Sold
          </Badge>
        );
      case 'damaged':
        return (
          <Badge bg="warning" className="d-flex align-items-center">
            <FaTimesCircle className="me-2" /> Damaged
          </Badge>
        );
      default:
        return (
          <Badge bg="secondary" className="d-flex align-items-center">
            <FaQuestionCircle className="me-2" /> Unknown - {status}
          </Badge>
        );
    }
  };

  return <>{getStatusBadge(String(status).toLowerCase())}</>;
};

export default ItemSalesStatusBadge;
